module.exports = ".main {\n    margin-top: 10px;\n}\n\n.main-not-found {\n    margin-top: 100px;\n    color: #fff;\n    font-size: 20px;\n    text-align: center;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/pagenotfound/pagenotfound.component.css
// module id = ./src/app/main/pagenotfound/pagenotfound.component.css
// module chunks = main